import React, {FC} from 'react';

import {DropdownItemSecondaryIcon} from './dropdownItemSecondaryIcon';

/*
 * Component.
 */

export const DropdownItemChevron: FC = () => (
  <DropdownItemSecondaryIcon label={null} iconName="chevronRightSmall" />
);
